class ShopperAnalytics {
    constructor(analytics) {
        this.analytics = analytics;
    }

    push(shopperService) {
        this.analytics.push({ data: { shopperDetails: shopperService }, type: this.analytics.mapperTypes.account.shopper });
    }
}

module.exports = ShopperAnalytics;



// WEBPACK FOOTER //
// ./src/auth/shopper/analytics/shopper-analytics.service.js